import * as Constants from './constants'

export const roleListRequest = function roleListRequest(formData) {
  return {
    type: Constants.ROLE_LIST_REQUESTING,
    payload: formData
  }
}

export const roleListSuccess = function roleListSuccess(data) {
  return {
    type: Constants.ROLE_LIST_SUCCESS,
    data
  }
}

export const roleListError = function roleListError(error) {
  return {
    type: Constants.ROLE_LIST_ERROR,
    error
  }
}

export const roleDetailRequest = function roleDetailRequest(formData) {
  return {
    type: Constants.ROLE_DETAIL_REQUESTING,
    payload: formData
  }
}

export const roleDetailSuccess = function roleDetailSuccess(data) {
  return {
    type: Constants.ROLE_DETAIL_SUCCESS,
    data
  }
}

export const roleDetailError = function roleDetailError(error) {
  return {
    type: Constants.ROLE_DETAIL_ERROR,
    error
  }
}
export const menuListRequest = function menuListRequest(formData) {
  return {
    type: Constants.MENU_LIST_REQUESTING,
    payload: formData
  }
}

export const menuListSuccess = function menuListSuccess(data) {
  return {
    type: Constants.MENU_LIST_SUCCESS,
    data
  }
}

export const menuListError = function menuListError(error) {
  return {
    type: Constants.MENU_LIST_ERROR,
    error
  }
}

export const usersListRequest = function usersListRequest(formData) {
  return {
    type: Constants.USERS_LIST_REQUESTING,
    payload: formData
  }
}

export const usersListSuccess = function usersListSuccess(data) {
  return {
    type: Constants.USERS_LIST_SUCCESS,
    data
  }
}

export const usersListError = function usersListError(error) {
  return {
    type: Constants.USERS_LIST_ERROR,
    error
  }
}

export const roleUpdateRequest = (formData, callback) => {
  return {
    type: Constants.ROLE_UPDATE_REQUESTING,
    payload: formData,
    callback
  }
}

export const roleUpdateSuccess = function roleUpdateSuccess(response) {
  return {
    type: Constants.ROLE_UPDATE_SUCCESS,
    payload: response
  }
}

export const roleUpdateError = function roleUpdateError(error) {
  return {
    type: Constants.ROLE_UPDATE_ERROR,
    error
  }
}


// WEBPACK FOOTER //
// ./src/views/Role/actions.js